import { CartItem } from '../redux/slices/cartSlice';
import { OrderRequest } from '../redux/slices/orderSlice';
import { getCartItemName, getCartItemImage, formatModifiersForDisplay } from './cartUtils';

export const formatModifiersForAPI = (modifiers: any[]) => {
  // Safety checks
  if (!modifiers || !Array.isArray(modifiers)) return [];
  
  const apiModifiers: any[] = [];
  
  modifiers.forEach(modifier => {
    if (!modifier || typeof modifier !== 'object' || !Array.isArray(modifier.options)) {
      return; // Skip invalid modifiers
    }
    
    modifier.options.forEach((option: any) => {
      if (!option || typeof option !== 'object') {
        return; // Skip invalid options
      }
      
      let constructedName = "";
      let finalPrice = 0;
      
      // Safe name construction with sub-option support
      if (option.subOption && 
          typeof option.subOption === 'object' && 
          option.subOption.selection &&
          typeof option.subOption.selection === 'string') {
        // With sub-option: "SubOptionName - OptionName" (matches display format order)
        constructedName = `${option.subOption.selection} - ${option.name || 'Unknown'}`;
        finalPrice = parseFloat(String(option.subOption.price || '0').replace('$', '')) || 0;
      } else {
        // Without sub-option: "OptionName"
        constructedName = option.name || 'Unknown Option';
        finalPrice = parseFloat(String(option.price || '0').replace('$', '')) || 0;
      }
      
      // Only add if we have a valid name and price
      if (constructedName && !isNaN(finalPrice)) {
        apiModifiers.push({
          modifier_name: constructedName,
          modifier_price: finalPrice
        });
      }
    });
  });
  
  return apiModifiers;
};

export const calculateTotalModifierPrice = (modifiers: any[]): string => {
  const formattedModifiers = formatModifiersForDisplay(modifiers);
  const totalPrice = formattedModifiers.reduce((sum, modifier) => sum + modifier.price, 0);
  return totalPrice.toFixed(2);
};

export const transformCartToOrderRequest = (
  cartItems: CartItem[],
  formData: {
    name: string;
    phone: string;
    email: string;
    specialRequests: string;
  },
  restaurantId: string,
  payNow: boolean,
  grandTotal: number
): OrderRequest => {
  return {
    restaurant_id: restaurantId,
    name: formData.name,
    phone: formData.phone,
    email: formData.email,
    special_requests: formData.specialRequests,
    order_type: "web",
    delivery_type: "pickup",
    pay_now: payNow,
    ordered_items: cartItems.map(item => ({
      name: getCartItemName(item),
      quantity: item.quantity,
      itemPrice: item.item.price?.toString() || item.totalPrice.toString(),
      modifiers: formatModifiersForAPI(item.selected.modifiers),
      modifier_price: calculateTotalModifierPrice(item.selected.modifiers),
      spice_level: item.selected.spice?.label || "",
      image: getCartItemImage(item) || "",
      total_item_price: item.totalPrice.toString()
    })),
    grand_total: grandTotal.toFixed(2)
  };
};
